var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('awsui-v-form',{ref:"form",staticClass:"form",attrs:{"label-width":_vm.formLayoutMode === 'horizontal' ? _vm.labelWidth : null,"model":_vm.value,"rules":_vm.formRules}},[_c('devax-form-fields',{attrs:{"definition":_vm.definition,"value":_vm.value,"readonly":_vm.readonly}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }